import React from 'react';
import { Navigate } from 'react-router-dom';
import { getValidSession } from '../pages/helpers/sessionUtils';

export const SuperAdminPrivateRoute = ({ children }) => {
    const token = localStorage.getItem('superAdminToken');
    if (!token) {
        return <Navigate to="/superadmin/login" replace />;
    }
    return children;
};

export const VendorPrivateRoute = ({ children }) => {
    const token = localStorage.getItem('authToken');
    const session = getValidSession();
    
    if (!token && !session) {
        return <Navigate to="/login" replace />;
    }
    return children;
};
